/* =========================================================
   Get Spliced – FINAL YMQ placement fix (PDP only)

   Moves these YMQ option boxes under the price:
   - properties[Leather Monogram Personalisation]
   - properties[Monogram Text]  (when it appears)

   Uses MutationObserver so it always wins vs YMQ re-renders.
   Does NOT touch any other YMQ fields.
   ========================================================= */

(function () {
  const MAIN_PROP = "properties[Leather Monogram Personalisation]";
  const DEP_PROP  = "properties[Monogram Text]";

  const RUN_FOR_MS = 90000;   // keep enforcing for 90s
  const TICK_MS    = 250;

  function isProductPage() {
    return (
      document.body &&
      (document.body.classList.contains("template-product") ||
        location.pathname.includes("/products/"))
    );
  }

  function getProductInfoRoot() {
    return (
      document.querySelector('product-info[id^="ProductInfo-"]') ||
      document.querySelector("product-info") ||
      document.querySelector(".product__info-wrapper") ||
      document.querySelector("#MainContent")
    );
  }

  function getPriceEl(root) {
    if (!root) return null;
    return root.querySelector('[id^="price-template--"]') || root.querySelector(".price");
  }

  function ensureAnchor(root) {
    if (!root) return null;

    let anchor = root.querySelector("#gs-ymq-leather-anchor");
    if (anchor) return anchor;

    const priceEl = getPriceEl(root);
    if (!priceEl) return null;

    anchor = document.createElement("div");
    anchor.id = "gs-ymq-leather-anchor";
    anchor.style.display = "block";

    // Put anchor directly under price
    priceEl.insertAdjacentElement("afterend", anchor);
    return anchor;
  }

  function findYmqBoxByProp(propName) {
    // YMQ sets the option container with data-name exactly like your inspect
    return document.querySelector(`.ymq-options-box[data-name="${CSS.escape(propName)}"]`);
  }

  function moveBoxAfter(targetBox, boxToMove) {
    if (!targetBox || !boxToMove) return;

    // If already directly after, nothing to do
    if (targetBox.nextElementSibling === boxToMove) return;

    targetBox.insertAdjacentElement("afterend", boxToMove);
  }

  function repositionOnce() {
    if (!isProductPage()) return false;

    const root = getProductInfoRoot();
    if (!root) return false;

    const anchor = ensureAnchor(root);
    if (!anchor) return false;

    const mainBox = findYmqBoxByProp(MAIN_PROP);
    if (!mainBox) return false; // only run on products with this option

    // 1) Put Leather Monogram box under price
    if (!anchor.contains(mainBox)) {
      anchor.appendChild(mainBox);
    }

    // 2) If/when Monogram Text exists, put it right under Leather box
    const depBox = findYmqBoxByProp(DEP_PROP);
    if (depBox) {
      // Ensure both are in the anchor, then order them
      if (!anchor.contains(depBox)) {
        anchor.appendChild(depBox);
      }
      moveBoxAfter(mainBox, depBox);
    }

    return true;
  }

  function startEnforcing() {
    const start = Date.now();

    // Safety interval (covers late loads)
    const timer = setInterval(() => {
      try { repositionOnce(); } catch (e) {}
      if (Date.now() - start > RUN_FOR_MS) clearInterval(timer);
    }, TICK_MS);

    // Observer (covers YMQ injecting / reordering after selection)
    const obs = new MutationObserver(() => {
      try { repositionOnce(); } catch (e) {}
      if (Date.now() - start > RUN_FOR_MS) obs.disconnect();
    });

    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
  }

  function init() {
    if (!isProductPage()) return;

    // Early kicks
    setTimeout(repositionOnce, 100);
    setTimeout(repositionOnce, 800);
    setTimeout(repositionOnce, 2000);
    setTimeout(repositionOnce, 5000);

    startEnforcing();
  }

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", init);
  document.addEventListener("shopify:section:load", init);
})();


(function () {
  function findSizeLegend() {
    // Look inside variant pickers for the Size fieldset legend/label
    const containers = document.querySelectorAll('variant-radios, variant-selects, .product-form');
    for (const c of containers) {
      // Dawn commonly uses fieldset + legend for option name
      const fieldsets = c.querySelectorAll('fieldset');
      for (const fs of fieldsets) {
        const legend = fs.querySelector('legend');
        if (!legend) continue;
        const text = (legend.textContent || '').trim().toLowerCase();
        if (text === 'size' || text.includes('size')) return legend;
      }

      // Some themes use label elements instead of legend
      const labels = c.querySelectorAll('label, .form__label, .product-form__input label');
      for (const lb of labels) {
        const text = (lb.textContent || '').trim().toLowerCase();
        if (text === 'size' || text.includes('size')) return lb;
      }
    }
    return null;
  }

  function moveSizeChartInlineWithSizeLabel() {
    const sizeChartBtn = document.querySelector('.best-fit-size-chart button.scr-open-size-chart');
    const sizeChartWrap = document.querySelector('.best-fit-size-chart');
    if (!sizeChartBtn || !sizeChartWrap) return;

    const sizeLegend = findSizeLegend();
    if (!sizeLegend) return;

    // Create an inline holder next to "Size" once
    let holder = sizeLegend.querySelector('.gs-sizechart-inline');
    if (!holder) {
      holder = document.createElement('span');
      holder.className = 'gs-sizechart-inline';
      holder.setAttribute('aria-hidden', 'false');
      sizeLegend.appendChild(holder);
    }

    // If already inside holder, we're done
    if (holder.contains(sizeChartBtn)) return;

    // Move ONLY the button inline, keep wrapper in place (prevents layout weirdness)
    holder.appendChild(sizeChartBtn);

    // Hide the original wrapper so it doesn’t leave a gap (button has moved)
    sizeChartWrap.style.display = 'none';
  }

  function removeYmqPriceSummary() {
  const root = document.querySelector('#ymq-box');
  if (!root) return;

  // Find any element that contains this exact message and hide its container
  const needles = ['selection will add', 'to the price'];

  const all = root.querySelectorAll('*');
  for (const el of all) {
    const txt = (el.textContent || '').trim().toLowerCase();
    if (!txt) continue;

    // Match the summary sentence (covers currency changes too)
    if (needles.every(n => txt.includes(n))) {
      // Hide the closest "boxed" container (or just the element itself)
      const box = el.closest('div, p, section, article') || el;
      box.style.display = 'none';
      break;
    }
  }
}



  function moveYmqBelowSizeChart() {
    // Keep your previous working behavior too (YMQ below size chart area)
    const ymq = document.querySelector('#ymq-box');
    if (!ymq) return;

    // After we inline the button, we can anchor YMQ after variant pickers (best effort)
    const variantArea =
      document.querySelector('variant-radios') ||
      document.querySelector('variant-selects') ||
      document.querySelector('.product__info-container');

    if (!variantArea) return;

    // Insert YMQ right after the variant area (so it sits after Size/Color + inline size chart)
    if (variantArea.nextElementSibling === ymq) return;
    variantArea.parentElement.insertBefore(ymq, variantArea.nextElementSibling);
  }
function runAll() {
  moveSizeChartInlineWithSizeLabel();
  moveYmqBelowSizeChart();
  forceYmqSingleSelectLikeRadio();

  // Step 2 layout fix (Vinyl/Glitter)
  forceCenterYmqStep2Rows();
}

function fixYmqStep2MaterialAlignment() {
  const ymq = document.querySelector('#ymq-box');
  if (!ymq) return;

  // Find the Step 2 title by text
  const step2Title = Array.from(ymq.querySelectorAll('*'))
    .find(el => el.childElementCount === 0 && /Step\s*2:\s*Choose\s*Customisation\s*Material/i.test(el.textContent || ''));

  if (!step2Title) return;

  // The option rows usually sit after the title within the same section/container.
  // We'll grab the nearest "block" container and tag any labels inside it until Step 3 starts.
  const step2Block = step2Title.closest('div, section, li') || ymq;

  // Add a hook class on the block so CSS can target it safely
  step2Block.classList.add('ymq-step2-material');

  // In case Step 2 options are not inside the closest block, also tag the next labels until Step 3
  let node = step2Title;
  let safety = 0;
  while (node && safety < 80) {
    safety++;
    node = node.nextElementSibling;
    if (!node) break;

    // Stop when Step 3 appears
    if (/Step\s*3:/i.test(node.textContent || '')) break;

    // Tag any labels/buttons inside
    node.querySelectorAll?.('label, button')?.forEach(el => el.classList.add('ymq-step2-material-option'));
  }
}
function forceCenterYmqStep2Rows() {
  const ymq = document.querySelector('#ymq-box');
  if (!ymq) return;

  // Prevent re-attaching multiple observers when runAll() runs repeatedly
  if (ymq.dataset.gsStep2CenterFix === '1') return;
  ymq.dataset.gsStep2CenterFix = '1';

  const apply = () => {
    // Find the Step 2 option labels by their visible text
    const labels = Array.from(ymq.querySelectorAll('label'))
      .filter(lab => /(vinyl|glitter)/i.test(lab.textContent || ''));

    if (!labels.length) return;

    labels.forEach((label) => {
      // Center the whole row
      label.style.display = 'flex';
      label.style.alignItems = 'center';
      label.style.justifyContent = 'center';
      label.style.gap = '10px';
      label.style.whiteSpace = 'nowrap';
      label.style.flexWrap = 'nowrap';
      label.style.textAlign = 'center';

      // Undo "push apart" / overlap culprits inside
      label.querySelectorAll('*').forEach((child) => {
        child.style.marginLeft = '0';
        child.style.marginRight = '0';
        child.style.float = 'none';
        child.style.position = 'static';
        child.style.transform = 'none';
      });
    });
  };

  // Apply now + whenever YMQ re-renders
  apply();
  const obs = new MutationObserver(apply);
  obs.observe(ymq, { childList: true, subtree: true });
}




  document.addEventListener('DOMContentLoaded', () => {
    runAll();

    // Re-run when apps/variants re-render
    const container =
      document.querySelector('.product__info-container') ||
      document.querySelector('main') ||
      document.body;

    const obs = new MutationObserver(() => runAll());
    obs.observe(container, { childList: true, subtree: true });
  });
})();

function forceYmqSingleSelectLikeRadio() {
  const root = document.querySelector('#ymq-box');
  if (!root) return;

  if (root.dataset.gsRadioFix === '1') return;
  root.dataset.gsRadioFix = '1';

  function getStepGroup(el) {
    let node = el;
    while (node && node !== root) {
      const inputs = node.querySelectorAll('input');
      if (inputs.length > 1) {
        // Identify a "Step" container by presence of "Step X:" text
        const hasStepTitle = Array.from(node.querySelectorAll('*')).some((n) =>
          ((n.textContent || '').trim().toLowerCase()).startsWith('step ')
        );
        if (hasStepTitle) return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  root.addEventListener('click', (e) => {
    const label = e.target.closest('label');
    if (!label) return;

    // Don't block the opener
    const labelText = (label.textContent || '').trim().toLowerCase();
    if (labelText.includes('add personalisation') || labelText.includes('add personalization')) {
      return;
    }

    const inputId = label.getAttribute('for');
    if (!inputId) return;

    const input = root.querySelector(`#${CSS.escape(inputId)}`);
    if (!input) return;

    // Only apply inside a Step container (Step 1, 2, 5 etc.)
    const group = getStepGroup(input) || getStepGroup(label);
    if (!group) return;

    // Ignore non-checkbox/radio inputs
    if (input.type !== 'checkbox' && input.type !== 'radio') return;

    // Now enforce radio-like behavior
    e.preventDefault();
    e.stopPropagation();

    const siblings = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');

    siblings.forEach((sib) => {
      if (sib !== input && sib.checked) {
        sib.checked = false;
        sib.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);
}

/* MOBILE YMQ FONT PREVIEW FIX */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isInsideFontStep(el) {
    return !!el.closest('#ymq-box div[data-name="Step 5: Select Font"]');
  }

  function getFontOption(el) {
    return el.closest(
      '#ymq-box div[data-name="Step 5: Select Font"] .ymq-option-box, ' +
      '#ymq-box div[data-name="Step 5: Select Font"] .ymq-options-box, ' +
      '#ymq-box div[data-name="Step 5: Select Font"] label'
    );
  }

  function getPreviewTrigger(option) {
    if (!option) return null;

    return option.querySelector(
      '[class*="arrow"], ' +
      '[class*="zoom"], ' +
      '[class*="preview"], ' +
      '.ymq-option-box-img i, ' +
      '.ymq-option-box-img svg, ' +
      '.ymq-option-box-img a'
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!isMobile()) return;
      if (!isInsideFontStep(e.target)) return;

      const option = getFontOption(e.target);
      if (!option) return;

      if (
        e.target.closest(
          '[class*="arrow"], [class*="zoom"], [class*="preview"]'
        )
      ) {
        return;
      }

      setTimeout(function () {
        const trigger = getPreviewTrigger(option);
        if (trigger) {
          trigger.click();
        }
      }, 120);
    },
    true
  );
})();